import { IsNotEmpty, IsNumber, IsOptional } from "class-validator";

export class CourseDocumentDto {
  @IsNotEmpty()
  name: string;

  @IsOptional()
  description?: string;

  @IsNotEmpty()
  file_url: string;

  @IsNotEmpty()
  file_name: string;

  @IsNumber()
  file_size: number;

  @IsNotEmpty()
  mime_type: string;
}

export class UpdateCourseDocumentDto {
  @IsOptional()
  name?: string;

  @IsOptional()
  description?: string;
}
